import { UserTraining } from './UserTraining'
import { v4 as uuidv4 } from 'uuid'

export interface UserTrainingDTO {
  id: string
  trainingID: string
  userID: string
  startDate: Date
  finishDate: Date
  frecuency: number // 1: mañana, 2: tarde, 3: noche
  series: number
  repetitions: number
  completed: boolean
}

export function emptyUserTrainingDTO(): UserTrainingDTO {
  return {
    id: uuidv4(),
    trainingID: '',
    userID: '',
    startDate: new Date(),
    finishDate: new Date(),
    frecuency: 0,
    series: 0,
    repetitions: 0,
    completed: false,
  }
}

export function fromModel(t: UserTraining): UserTrainingDTO {
  return {
    id: t.id,
    trainingID: t.trainingID,
    userID: t.userID,
    startDate: t.startDate,
    finishDate: t.finishDate,
    frecuency: t.frecuency,
    series: t.series,
    repetitions: t.repetitions,
    completed: t.completed,
  }
}

export function toModel(d: UserTrainingDTO): UserTraining {
  return new UserTraining(d)
}
